
// Supplier Rejection functions
var TECL_SupplierRejection = {

  // Display the rejection dialog
  DisplayRejectionDialog: function(tenderSupplierId, supplierName, rowId, stageName) {

    var $parent = $("#" + rowId);
    if ($parent && $parent.hasClass("reject-select-disabled")) {
      return;
    }

    var tenderId = $("#TenderId").val();

    if (tenderId) {
      var tenderName = $("#TenderName").val();
      var displayRejectionDlg = true;

      if (displayRejectionDlg && TECL_Master.AddLock("TECL_SupplierRejection_DisplayRejectionDialog")) {
        $.ajax({
          url: baseSiteUrl + "TenderUserSurface/GetRejectionDialog",
          type: "POST",
          data: {
            tenderId: tenderId,
            tenderName: tenderName,
            tenderSupplierId: tenderSupplierId,
            supplierName: supplierName,
            rowId: rowId,
            stageName: stageName
          },
          error: function() {
            TECL_Master.ClearLock("TECL_SupplierRejection_DisplayRejectionDialog");
            TECL_Master.ShowErrorDialog();
          },
          success: function(view) {
            TECL_Master.ClearLock("TECL_SupplierRejection_DisplayRejectionDialog");

            if (view) {
              $("#supplierRejectionDialogDiv").html(view);
              $("#supplierRejectionDialog").modal("show");
              TECL_SupplierRejection.InitialiseCheckboxes();

            } else {
              TECL_Master.ShowErrorDialog();
            }
          }
        });
      }
    }
  },

  // Display the last rejection dialog
  DisplayLastRejectionDialog: function(tenderId, tenderName, tenderSupplierId, supplierName, stageName) {
    if (TECL_Master.AddLock("TECL_SupplierRejection_DisplayLastRejectionDialog")) {
      $.ajax({
        url: baseSiteUrl + "TenderUserSurface/GetLastSupplierRejectionDialog",
        type: "POST",
        data: {
          tenderId: tenderId,
          tenderName: tenderName,
          tenderSupplierId: tenderSupplierId,
          supplierName: supplierName,
          stageName: stageName
        },
        error: function() {
          TECL_Master.ClearLock("TECL_SupplierRejection_DisplayLastRejectionDialog");
          TECL_Master.ShowErrorDialog();
        },
        success: function(view) {
          TECL_Master.ClearLock("TECL_SupplierRejection_DisplayLastRejectionDialog");

          if (view) {
            $("#lastSupplierRejectionDialogDiv").html(view);
            $("#lastSupplierRejectionDialog").modal("show");
          } else {
            TECL_Master.ShowErrorDialog();
          }
        }
      });
    }
  },

  // Apply the rejections
  RejectSupplier: function(tenderId, tenderSupplierId, rowId, stageName, supplierName) {
    var dialog = $("#supplierRejectionDialog");

    if (tenderSupplierId && dialog && dialog.length > 0 && TECL_SupplierRejection.ValidateRejections()) {

      var selectedFieldNames = [];
      var nonSelectedFieldNames = [];
      dialog.find("[name=rejectionSelection]").each(function() {
        if ($(this).is(":checked")) {
          selectedFieldNames.push({
            FieldName: $(this).attr("data-fieldName"),
            FieldLabel: $(this).attr("data-fieldLabel")
          });

        } else {
          nonSelectedFieldNames.push($(this).attr("data-fieldName"));
        }
      });

      var additionalInfoFieldName = null;
      var additionalInfo = null;
      var additionalInfoElement = dialog.find("[name=rejectionAdditionalInfoText]");

      if (additionalInfoElement && additionalInfoElement.length > 0) {
        additionalInfo = $(additionalInfoElement).val();
        additionalInfoFieldName = $(additionalInfoElement).attr("data-fieldName");
      }

      if (TECL_Master.AddLock("TECL_SupplierRejection_RejectSupplier")) {
        $.ajax({
          url: baseSiteUrl + "TenderUserSurface/SaveRejectionResults",
          type: "POST",
          data: {
            tenderId: tenderId,
            tenderSupplierId: tenderSupplierId,
            stageName: stageName,
            selectedFieldNames: selectedFieldNames,
            nonSelectedFieldNames: nonSelectedFieldNames,
            additionalInfoFieldName: additionalInfoFieldName,
            additionalInfo: additionalInfo
          },
          error: function() {
            TECL_Master.ClearLock("TECL_SupplierRejection_RejectSupplier");
            TECL_Master.ShowErrorDialog();
          },
          success: function() {
            TECL_Master.ClearLock("TECL_SupplierRejection_RejectSupplier");
            if (stageName) {
              $("#supplierRejectionDialog").modal("hide");

              if (stageName == "shortlist") {
                TECL_UserTenderShortlistEdit.ChangeSupplierTenderStatus(tenderSupplierId, rowId, "reject");
              } else {
                TECL_UserTenderPresentationEdit.ChangeSupplierTenderStatus(tenderSupplierId, rowId, "reject");
              }

              // Show last supplier rejection dialog if required
              var isLastRejection = TECL_UserTenderPresentationEdit.IsLastRejection();
              if (isLastRejection) {
                var tenderName = $("#TenderName").val();
                TECL_SupplierRejection.DisplayLastRejectionDialog(tenderId, tenderName, tenderSupplierId, supplierName, stageName);
              }

            } else {
              TECL_Master.ShowErrorDialog();
            }
          }
        });
      }
    }
  },

  // Validate rejection selections
  ValidateRejections: function() {
    var isValid = true;
    var dialog = $("#supplierRejectionDialog");

    if (dialog && dialog.length > 0) {
      var selectionMade = false;
      var otherSelected = false;
      dialog.find("[name=noSelectionMadeErr]").addClass("hidden");
      dialog.find("[name=noOtherMessageErr]").addClass("hidden");

      // Find if any selecctions have been made
      dialog.find("[name=rejectionSelection]").each(function() {
        if ($(this).is(":checked")) {

          if ($(this).attr("data-fieldname") == "SupplierRejectionOther") {
            otherSelected = true;
          }

          selectionMade = true;
        }
      });

      if (otherSelected) {
        // Validate that the message has text if the other selection is selected
        var additionalInfoElement = dialog.find("[name=rejectionAdditionalInfoText]");
        if (additionalInfoElement && additionalInfoElement.length > 0) {
          var message = additionalInfoElement.val();

          if (!message || message.length < 1) {
            dialog.find("[name=noOtherMessageErr]").removeClass("hidden");
            isValid = false;
          }
        }

      } else if (!selectionMade) {

        // no selections made
        dialog.find("[name=noSelectionMadeErr]").removeClass("hidden");
        isValid = false;
      }
    }
    return isValid;
  },

  // Setup the checkboxes and the change events
  InitialiseCheckboxes: function() {

    // Added change event to checkboxes
    $("[name='rejectionSelection']").change(function() {
      TECL_TenderGeneral.ChangedCheckboxLabelClass($(this));
    });

    // Update the classes for all checkbox labels
    $("[name='rejectionSelection']").each(function() {
      TECL_TenderGeneral.ChangedCheckboxLabelClass($(this));
    });
  }

};
